import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="advanced-search"
export default class extends Controller {
  static targets = ["filtersPanel", "searchForm"]

  connect() {
    console.log("Advanced search controller connected")
    this.loadSavedState()
  }

  toggleFilters() {
    const panel = this.filtersPanelTarget
    const isHidden = panel.classList.contains("hidden")
    
    if (isHidden) {
      panel.classList.remove("hidden")
      this.saveState("filtersOpen", true)
    } else {
      panel.classList.add("hidden")
      this.saveState("filtersOpen", false)
    }
  }

  search(event) {
    // Add loading state
    const submitButton = event.target.querySelector('input[type="submit"]')
    if (submitButton) {
      submitButton.disabled = true
      submitButton.value = "Searching..."
    }

    // Save current search state
    this.saveSearchState()
  }

  clearFilters() {
    // Reset all form fields
    const form = this.searchFormTarget
    const inputs = form.querySelectorAll('input, select')
    
    inputs.forEach(input => {
      if (input.type === 'text' || input.type === 'number' || input.type === 'date') {
        input.value = ''
      } else if (input.type === 'select-one') {
        input.selectedIndex = 0
      }
    })

    // Clear saved state
    this.clearSavedState()
  }

  saveSearchState() {
    const form = this.searchFormTarget
    const formData = new FormData(form)
    const searchData = {}
    
    for (let [key, value] of formData.entries()) {
      if (value) {
        searchData[key] = value
      }
    }
    
    this.saveState("lastSearch", searchData)
  }

  loadSavedState() {
    const filtersOpen = this.getState("filtersOpen")
    if (filtersOpen) {
      this.filtersPanelTarget.classList.remove("hidden")
    }
  }

  saveState(key, value) {
    try {
      localStorage.setItem(`schedule_search_${key}`, JSON.stringify(value))
    } catch (e) {
      console.warn("Could not save search state:", e)
    }
  }

  getState(key) {
    try {
      const value = localStorage.getItem(`schedule_search_${key}`)
      return value ? JSON.parse(value) : null
    } catch (e) {
      console.warn("Could not load search state:", e)
      return null
    }
  }

  clearSavedState() {
    try {
      const keys = Object.keys(localStorage).filter(key => key.startsWith('schedule_search_'))
      keys.forEach(key => localStorage.removeItem(key))
    } catch (e) {
      console.warn("Could not clear search state:", e)
    }
  }

  // Quick filter shortcuts
  filterByStatus(event) {
    const status = event.target.dataset.status
    const statusSelect = this.searchFormTarget.querySelector('select[name="validation_status"]')
    if (statusSelect) {
      statusSelect.value = status
      this.searchFormTarget.requestSubmit()
    }
  }

  filterByQuality(event) {
    const quality = event.target.dataset.quality
    const qualityInput = this.searchFormTarget.querySelector('input[name="min_quality"]')
    if (qualityInput) {
      qualityInput.value = quality
      this.searchFormTarget.requestSubmit()
    }
  }

  // Real-time search with debouncing
  searchInput(event) {
    clearTimeout(this.searchTimeout)
    this.searchTimeout = setTimeout(() => {
      this.searchFormTarget.requestSubmit()
    }, 500)
  }
}